export default "__VITE_ASSET__Du7W08U7__"